import React, { Component } from 'react';
import { connect } from 'react-redux';

import { handleReferBusiness } from '../../actions/index';
import formatPhoneForUser from '../../utils/formatPhoneForUser';

import { Input } from '@/components/ui/input';

import { Button } from '@/components/ui/button';

import {
	DialogFooter,
	DialogContent,
	DialogTitle,
	DialogClose,
} from '@/components/ui/dialog';

const formatPhone = (i) => {
	return formatPhoneForUser(i);
};

class ReferralDialog extends Component {
	constructor(props) {
		super(props);
		this.state = {
			businessName: '',
			contactName: '',
			email: '',
			phone: '',
		};
	}

	submit = async () => {
		const { businessName, contactName, email, phone } = this.state;

		await this.props.handleReferBusiness({
			businessName,
			contactName,
			email,
			phone,
		});
	};

	handleBusinessNameChange = (e) => {
		this.setState({ businessName: e.target.value });

		if (e.target.value === 'crash') {
			this.crash.me(yes);
		}
	};

	handleContactNameChange = (e) => {
		this.setState({ contactName: e.target.value });
	};

	handleEmailChange = (e) => {
		this.setState({ email: e.target.value });
	};

	onPhoneChange = (val) => {
		const phone = formatPhone(val);
		this.setState({ phone });
	};

	handleCancel = () => {
		this.setState({ phone: '' });
	};

	renderActions = () => {
		const { businessName, contactName, email, phone } = this.state;

		return (
			<div className="flex flex-row justify-end max-md:flex-col-reverse max-md:gap-2 max-md:[&_button]:h-11 max-md:[&_button]:w-full">
				<div className="mr-2.5 max-md:mr-0">
					<DialogClose asChild>
						<Button variant="ghost" onClick={this.handleCancel}>
							Cancel
						</Button>
					</DialogClose>
				</div>
				<DialogClose asChild>
					<Button
						disabled={
							!(businessName && contactName && email && phone)
						}
						onClick={this.submit}
					>
						Submit
					</Button>
				</DialogClose>
			</div>
		);
	};

	render() {
		return (
			<DialogContent>
				<DialogTitle>Refer a business to Chekkit </DialogTitle>

				<div className="flex flex-col w-[100%]">
					<div>
						Refer another business to Chekkit and get{' '}
						<strong>1 free month</strong> of service if they sign up{' '}
						<span role="img" aria-label="party-emoji">
							🎉
						</span>
					</div>
					<div className="mt-2.5 w-[100%]">
						<div className="mb-2.5 w-[100%]">
							<Input
								id="business-name"
								className="w-[100%]"
								aria-label="Business name"
								autoComplete="organization"
								enterKeyHint="next"
								placeholder="Business Name"
								onChange={this.handleBusinessNameChange}
								variant="outlined"
							/>
						</div>
						<div className="mb-2.5">
							<Input
								id="contact-name"
								aria-label="Contact name"
								autoComplete="name"
								enterKeyHint="next"
								placeholder="Contact Name"
								onChange={this.handleContactNameChange}
								variant="outlined"
								className="w-[100%]"
							/>
						</div>
						<div className="mb-2.5">
							<Input
								id="email"
								type="email"
								inputMode="email"
								autoComplete="email"
								autoCapitalize="none"
								enterKeyHint="next"
								aria-label="Email"
								placeholder="Email"
								onChange={this.handleEmailChange}
								variant="outlined"
								className="w-[100%]"
							/>
						</div>
						<div>
							<Input
								id="phone"
								type="tel"
								inputMode="tel"
								autoComplete="tel"
								enterKeyHint="done"
								aria-label="Phone"
								placeholder="Phone"
								onChange={(event) =>
									this.onPhoneChange(event.target.value)
								}
								value={this.state.phone}
								variant="outlined"
								className="w-[100%]"
							/>
						</div>
					</div>
				</div>

				<DialogFooter> {this.renderActions()}</DialogFooter>
			</DialogContent>
		);
	}
}

export default connect(null, { handleReferBusiness })(ReferralDialog);
